import {IAppContextProps} from "./AppContext.interfaces";
import {Loader, Provider} from "@fluentui/react-northstar";
import {AppContext} from "./AppContext";
import {useAppContext} from "./AppContext.hook";
import {ConsentPage} from "auth/TeamsFx/ConsentPage/ConsentPage";
import React from "react";

export const AppContextProvider = (props: IAppContextProps) => {
    const value = useAppContext();

    return (
        <AppContext.Provider value={value}>
            <Provider lang={value.teams.locale} theme={value.teams.teamsTheme}>
                {!value.initialized ?
                    <Loader styles={{height: "100%"}}/>
                    :
                    !value.loaded ?
                        <ConsentPage/>
                        :
                        props.children
                }
            </Provider>
        </AppContext.Provider>
    )
}